import { gql } from "@apollo/client";

// Mutations
export const UPDATE_CONFIRM_STEP = gql`
  mutation updateReviewStep {
    updateReviewApplicationStep {
      status
      message
    }
  }
`;
